export default __webpack_public_path__ + "static/media/cardcomming.0996c626.jpg";